import React from 'react';
import PropTypes from 'prop-types';
import InProgressJobPageContent from './inProgressJobPageContent';
import InProgressTaskPageContent from './inProgressTaskPageContent';

class InProgressPageContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      model: 'task',
    };
  }

  _onModelChange = (model) => {
    this.setState({ model });
  }

  render() {
    if (this.state.model === 'task') {
      return (
        <InProgressTaskPageContent
          onModelChange={this._onModelChange}
        >
          {this.props.children}
        </InProgressTaskPageContent>
      );
    }

    return (
      <InProgressJobPageContent
        onModelChange={this._onModelChange}
      >
        {this.props.children}
      </InProgressJobPageContent>
    );
  }
}

InProgressPageContent.displayName = 'In Progress Page Content';

InProgressPageContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InProgressPageContent;
